export enum TipoEnvioComprovanteEnum {

    MAIL = 'MAIL',

    SMS = 'SMS'

}
